import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';

import * as styles from './styles.css';

export default function IconPopover({ title, children, iconClasses, tooltipPlacement }) {
  return (
    <OverlayTrigger
      placement={tooltipPlacement ? tooltipPlacement : "right"}
      overlay={
        <Popover
          id="overload-right"
          title={title}
          className={styles.tooltip}
        >
          {children}
        </Popover>
      }
    >
      <i className={`fa ${iconClasses}`} />
    </OverlayTrigger>
  );
}

IconPopover.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  iconClasses: PropTypes.string.isRequired,
};

